import { PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';

// 全局通用可视化，三类icon
export const CHARTICONALL = [
  { type: 'bar-horizontal', context: 'dbi_bar_chart', icon: 'histogram-skew' },
  { type: 'bar', context: 'dbi_bar_chart', icon: 'column-chart' },
  { type: 'line', context: 'dbi_line_chart', icon: 'discount-chart' },
  { type: 'pie', context: 'dbi_pie_chart', icon: 'pie-chart-icon' },
];

// 可视化通用颜色范围  -- 可视化纯色配色，用于 柱状图单柱子、饼状图
export const ECHARTSCOLOR = [
  // Color5
  '#5086f3',
  '#5ec8f1',
  '#69d19c',
  '#f5d242',
  '#f19e55',
  '#f17c86',
  '#ad53d4',
  '#7f6ff1',
  '#488e89',
  '#6e7794',
  '#6a7597',
  '#2648a6',
  '#307da6',
  '#358561',
  '#a8831d',
  '#a65b29',
  '#a64453',
  '#642787',
  '#413ca6',
  '#245552',
  '#2e3247',
];

// 第一深色（Color3）
export const FIRST_COLORS = [
  '#2648a6',
  '#307da6',
  '#358561',
  '#a8831d',
  '#a65b29',
  '#a64453',
  '#642787',
  '#413ca6',
  '#245552',
  '#2e3247',
];
// 第二深色（Color5）
export const SECOND_COLORS = [
  '#5086f3',
  '#5ec8f1',
  '#69d19c',
  '#f5d242',
  '#f19e55',
  '#f17c86',
  '#ad53d4',
  '#7f6ff1',
  '#488e89',
  '#6e7794',
  '#6a7597',
];
// 第三深色（Color7）
export const THIRD_COLORS = [
  '#a6c9ff',
  '#b5efff',
  '#c0ebd2',
  '#fff196',
  '#ffd8ab',
  '#ffcccc',
  '#dfb2ed',
  '#d2c8fd',
  '#a9c7c3',
  '#b8bed1',
];
// 第四深色
// export const FIRTH_COLORS = ['#D7E7FD', '#A3FCFE', '#A6FCC0', '#FCEC7D', '#FADF97', '#F7CBCE', '#F7CDFC', '#E2CFFC', '#D9DCE2', '#D8DEE0'];

// 颜色值列表，柱状图 柱子颜色列表
export const COLORS = [
  '#376AE7',
  '#3ECBFF',
  '#4FCB87',
  '#FFD14E',
  '#ED9142',
  '#E95F6A',
  '#CF61AC',
  '#8164CD',
  '#6585F7',
  '#A0B6FA',
];

// 柱状图配色
export const BAR_COLORS = [FIRST_COLORS, SECOND_COLORS, THIRD_COLORS];

// 折线图配色
export const LINE_COLORS = [FIRST_COLORS, SECOND_COLORS, THIRD_COLORS];

// 饼状图配色
export const PIE_COLORS = [ECHARTSCOLOR, ECHARTSCOLOR, ECHARTSCOLOR];

// 可视化canvas画不同类型尺寸比例
export const IMGE_STAMDARDS_CANVAS: { [key: string]: any } = {
  mobile: {
    width: 30,
    height: 30,
  },
  pc: {
    width: 60,
    height: 28,
  },
  console: {
    width: 28,
    height: 35,
  },
  // pc、console联合游戏类型，游戏icon尺寸跟console保持一致
  [PC_CONSOLE_COMBINE_ENTITY_TYPE]: {
    width: 28,
    height: 35,
  },
  region: {
    width: 30,
    height: 30,
  },
  market: {
    width: 24,
    height: 16,
  },
  company: {
    width: 30,
    height: 30,
  },
  user: {
    width: 30,
    height: 30,
  },
} as any;

// 可视化通用颜色范围  -- 可视化纯色配色，用于 柱状图单柱子、饼状图
export const COUNTRIESBARCOLOR = [...ECHARTSCOLOR, ...ECHARTSCOLOR, ...ECHARTSCOLOR];

export enum RenderType {
  VALUE_AND_RATIO, // 默认 值+环比
  VALUE_AND_RATIO_NOPOINT, // 默认 值+环比(环比没有小数据点，小于1大于0才有)
  GROWTH_ONLY, // 仅百分比
  GROWTH_ONLY_PERCENTVALUE, // 仅百分比，且不用*100，仅加%
  VALUE_ONLY, // 仅数值
  GROWTH_AND_RATIO, // 百分比+环比
  RANK_AND_RATIO, // 名次和名次环比
  TEXT, // 文本
  PRICE, // 价格，0展示Free
}

export const EST_Revenue_Info = `Revenue($) of Steam Games only, estimates based on Steam reviews. Here VG insights only include the revenue of the Base game, but no DLC or MTX data, so the revenue of the Free-to-Play game is not provided. Users can refer to the digital revenue provided by Mscience to see the overall revenue data of a single game, which can be separated by different segments such as Base Game, MTX, DLC, etc.`;
export const EST_Units_Info = `Units Sold of Steam Games only, estimates based on Steam reviews. Here only providing the units sold of the Base game, therefore the credibility of units data is relatively higher for Paid Games than Free-to-Play Games. Users can refer to the digital revenue provided by Mscience to see the overall sales data of a single game, which can be separated by different segments such as Base Game, MTX, DLC, etc.`;
export const EXT_Price = `Daily price of this game in USD($), take the average when selected for weeks or months.`;

export const SteamSalesList = [
  {
    text: 'dbi_metric_alinea_steam_est_revenue', // 表格头部
    textRatio: 'Steam Revenue($)%', // 表格环比头部
    metricName: 'Steam Revenue($)', // 卡片指标名及SortBy展示
    metricNameRatio: 'Steam Revenue($)%', // 卡片指标名的环比SortBy展示
    value: 'alinea__est_revenue',
    info: EST_Revenue_Info,
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
    dataSource: 'alinea',
    width: 200,
    globalOnly: true,
    chartMsg: {
      topDefault: 'bar',
      countryDefault: 'bar',
      statsDefault: 'line',
    },
  },
  // {
  //   text: 'Cumulative Revenue($)',//表格头部
  //   textRatio: 'Cumulative Revenue($)%', //表格环比头部
  //   metricName: 'Cumulative Revenue($)', //卡片指标名及SortBy展示
  //   metricNameRatio: 'Cumulative Revenue($)%', //卡片指标名的环比SortBy展示
  //   value: 'est_cumulative_revenue',
  //   info: EST_Revenue_Info,
  //   renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  //   dataSource: 'vginsights',
  //   width: 200,
  //   globalOnly: true,
  //   ifDetailOnly: true,
  //   chartMsg: {
  //     topDefault: 'line',
  //     countryDefault: 'line',
  //     statsDefault: 'line',
  //   }
  // },
  {
    text: 'dbi_metric_units',
    textRatio: 'Units(%)',
    metricName: 'Units',
    metricNameRatio: 'Units(%)',
    value: 'alinea__est_units',
    info: EST_Units_Info,
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
    dataSource: 'alinea',
    width: 200,
    globalOnly: true,
    chartMsg: {
      topDefault: 'bar',
      countryDefault: 'bar',
      statsDefault: 'line',
    },
  },
  // {
  //   text: 'Cumulative Units',
  //   textRatio: 'Cumulative Units(%)',
  //   metricName: 'Cumulative Units',
  //   metricNameRatio: 'Cumulative Units(%)',
  //   value: 'est_cumulative_units',
  //   info: '',
  //   renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  //   dataSource: 'vginsights',
  //   width: 200,
  //   globalOnly: true,
  //   ifDetailOnly: true,
  //   chartMsg: {
  //     topDefault: 'line',
  //     countryDefault: 'line',
  //     statsDefault: 'line',
  //   }
  // },
  {
    text: 'dbi_metric_jptb_price',
    textRatio: 'Price($)%',
    metricName: 'Price($)',
    metricNameRatio: 'Price($)%',
    value: 'alinea__est_price',
    info: EXT_Price,
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
    dataSource: 'alinea',
    width: 150,
    globalOnly: true,
    chartMsg: {
      topDefault: 'line',
      countryDefault: 'line',
      statsDefault: 'line',
    },
  },
  {
    text: 'dbi_metric_weighted_price',
    textRatio: 'Weighted Price($)%',
    metricName: 'Weighted Price($)',
    metricNameRatio: 'Weighted Price($)%',
    value: 'alinea__weighted_price',
    info: `Weighted price of this game in USD($) is derived based on daily units sold.`,
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
    dataSource: 'alinea',
    width: 200,
    globalOnly: true,
    chartMsg: {
      topDefault: 'line', // 三态都有
      countryDefault: 'line',
      statsDefault: 'line',
    },
  },
  // {
  //   text: 'Lifetime weighted price($)',
  //   textRatio: 'Lifetime weighted price($)%',
  //   metricName: 'Lifetime weighted price($)',
  //   metricNameRatio: 'Lifetime weighted price($)%',
  //   value: 'lifetime_weighted_price',
  //   info: '',
  //   renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
  //   dataSource: 'vginsights',
  //   width: 200,
  //   globalOnly: true,
  //   ifDetailOnly: true,
  //   chartMsg: {
  //     topDefault: 'line',//三态都有
  //     countryDefault: 'line',
  //     statsDefault: 'line',
  //   }
  // },
  {
    text: 'dbi_metric_players_by_country',
    metricName: 'Players by country',
    value: 'alinea__players_by_country',
    info: `Country distribution of players, based on review languages.`,
    renderType: RenderType.VALUE_ONLY,
    dataSource: 'alinea',
    width: 300,
    chartMsg: {
      topDefault: 'bar', // 榜单默认堆叠，详情Country默认单柱
      topDisableLine: true,
      topDisablePie: true,
      countryDefault: 'bar',
      countryDisableLine: true,
      countryDisablePie: true,
      statsDefault: 'bar',
    },
  },
  {
    text: 'dbi_metric_playtime',
    value: 'alinea__playtime',
    metricName: 'Avg. Playtime',
    info: `Total average time spent per player on this game in minutes.`,
    renderType: RenderType.VALUE_ONLY,
    dataSource: 'alinea',
    width: 200,
    globalOnly: true,
    chartMsg: {
      topDefault: 'bar',
      topDisableLine: true,
      countryDefault: 'line',
      countryDisableLine: true,
      statsDefault: 'line',
    },
  },
  {
    text: 'dbi_metric_followers',
    value: 'alinea__steamfollowers',
    metricName: 'Total followers',
    info: `The total followers of the game as of now.`,
    renderType: RenderType.VALUE_ONLY,
    dataSource: 'alinea',
    width: 200,
    globalOnly: true,
    chartMsg: {
      topDefault: 'bar',
      topDisableLine: true,
      countryDefault: 'line',
      countryDisableLine: true,
      statsDefault: 'line',
    },
  },
];

export const PIE_CHART_TOOLTIP_BASE_OPTION = {
  trigger: 'item',
  padding: 0,
  borderWidth: 0,
  backgroundColor: 'rgba(255, 255, 255, 0)',
};

// 预测数据icon（矢量图的path路径）
export const PREDICT_DATA_SVG_ICON_PATH =
  'M5,0h.424l.029,0H5.6L5.708.05h.044l.024,0h0A4.988,4.988,0,0,1,8.586,1.516L7.511,2.561A3.473,3.473,0,0,0,5,1.5V0ZM9.661,3.187q.074.189.132.385h0l.007.022h0v.034l0,.009v.024h0v0h0l.009.034h0a4.986,4.986,0,0,1,.157.929h0l0,.029h0v.007h0v0h0v0h0v0h0v0h0v0h0v0h0V4.71h0v.026h0v.051h0v0h0v.15h0v.008h0v.038h0v0h0s0,0,0,0,0,0,0,0v.051h0v.113h0v.058h0v.052h0v.007h0v.048h0v.054h0v.014h0v.039h0v.015h0V5.5h0l0,.019h0v0h0v0h0v.011h0v0h0v0h0l0,.039h0v0h0v0h0v0h0v0h0v0h0l0,.035h0v0h0v0h0v0h0v0h0a4.965,4.965,0,0,1-.409,1.42L8.184,6.455a3.516,3.516,0,0,0,.079-2.724l1.4-.544Zm-2.3,4.393L8.378,8.686a5.019,5.019,0,0,1-.765.578h0l0,0,0,0,0,0,0,0,0,0-.012.007h0L7.57,9.29h0l0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0l0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0L7.45,9.36l0,0,0,0,0,0h0l0,0,0,0,0,0L7.383,9.4h0a4.966,4.966,0,0,1-1.746.563h0l-.059.007h-.02l-.047,0H5.48l-.032,0H5.412l-.024,0H4.939l-.164,0H4.759l-.049,0,.086-1.5c.068,0,.136.006.2.006A3.49,3.49,0,0,0,7.365,7.581Zm-5.7-1.5A3.524,3.524,0,0,0,3.453,8.141L2.789,9.486A5.022,5.022,0,0,1,.879,7.832h0l0,0h0l0,0h0l0,0h0l0,0h0l0,0h0l0,0h0l0,0h0l0,0h0l0,0h0L.831,7.761h0l0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0v0L.772,7.67l0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0l0,0,0,0,0,0A4.974,4.974,0,0,1,.242,6.54Zm.172-4.954.948,1.162A3.469,3.469,0,0,0,1.513,4.694L.019,4.565A4.979,4.979,0,0,1,1.193,1.759l0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0l.007-.008h0l0-.005,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0l0-.005h0l.025-.027,0,0,0,0h0l0-.005,0,0h0l0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0a5.03,5.03,0,0,1,.413-.378ZM5,0V1.5a3.508,3.508,0,0,0-.981.139L3.6.2A4.969,4.969,0,0,1,4.175.068h0l.011,0H4.2l.011,0h.005l.011,0,.011,0H5Z';
// 预测数据icon（矢量图），用于预测数据对应的图例icon
export const PREDICT_DATA_SVG_ICON = `path://${PREDICT_DATA_SVG_ICON_PATH}`;
